import { Box } from '@mui/material'
import React from 'react'
import Navbar from '../components/Navbar'
import AccountSettings from '../components/Profile/Account';
const Profile = () => {
  return (
    <>
      <Navbar title="Profile" />
      <Box style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1.5rem" }}>
       <AccountSettings/>
      </Box>
    </>
  )
}

export default Profile